export const deriveStatus = (test) => {
  if (!test.is_published) return 'draft';
  if (test.assigned_count > 0 && test.completed_count >= test.assigned_count) return 'completed';
  if (test.scheduled_at && new Date(test.scheduled_at) > new Date()) return 'scheduled';
  return 'active';
};

export const statusMeta = (status) => {
  switch (status) {
    case 'draft':
      return { label: 'Draft', color: '#64748b', bg: '#f1f5f9' }; // Slate
    case 'scheduled':
      return { label: 'Scheduled', color: '#d97706', bg: '#fbf0e0' }; // Yellow
    case 'active':
      return { label: 'Active', color: '#059669', bg: '#e5f4ef' }; // Green
    case 'completed':
      return { label: 'Completed', color: '#4f46e5', bg: '#ecebfd' }; // Blue
    default:
      return { label: 'Unknown', color: '#94a3b8', bg: '#fbfaff' };
  }
};

export const canEdit = (test) => {
  return (test.completed_count || 0) === 0;
};

export const canDelete = (test) => {
  return (test.completed_count || 0) === 0;
};
